import { useEffect, useState } from "react";
import { useFlowyGlobalContext } from "flowy-3-core";
import { FlowyProject } from "../components/gizmos";
import usePlatformCB from "./usePlatformCB";
import * as S from "./BaseProject.styles";
import useAuth from "./useAuth";
import { beneficiaryProject } from "./gizmoConfigurations";

/**
 *  We created this in order to not touch the DefaultProject component.
 */
const BaseProject: React.FC = () => {
  // Uncomment this to use the default project
  const [project, setProject] = useState<any>(beneficiaryProject);
  // const [project, setProject] = useState<any>(undefined);
  const { isAuthenticated } = useAuth();
  const { platformOperationCB, params } = usePlatformCB();
  const flowyGlobal = useFlowyGlobalContext();

  useEffect(() => {
    if (isAuthenticated !== undefined && flowyGlobal) {
      const projects = flowyGlobal.getProjects({
        authenticated: isAuthenticated,
      });
      if (projects && projects.length > 0) {
        setProject(projects[0]);
      }
      flowyGlobal.projects.subscribe((projects) => {
        console.log("subs.projects: ", projects);
        // setProject(clone(projects[0]));
        setProject(undefined);
      });
    }
  }, [isAuthenticated, flowyGlobal]);

  return (
    <S.BaseProject>
      {project && (
        <FlowyProject
          config={project}
          platformCallbacks={{
            platformOperationCB,
          }}
          params={params}
        />
      )}
    </S.BaseProject>
  );
};

export default BaseProject;
